
export default (min, max) => {
    const __min = Number.isInteger(min) ? min : 0;
    const __max = Number.isInteger(max) ? max : 999999;
    console.log("random", __min, __max)

    return Math.floor(Math.random() * (__max + 1 - __min)) + __min;
}